/* prettier-ignore */

import { Component,inject,input, InputSignal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';

@Component({
  selector: 'cards-mobile-map',
  imports: [CommonModule, TranslateModule],
  standalone: true,
  templateUrl: './mobile-cards.component.html',
  styleUrls: ['./mobile-cards.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class CardsMobileMapComponent {
  public pointsPerDay: InputSignal<any> = input.required<any>();  
  public mobileCardColor: InputSignal<any> = input.required<any>();  
  private routeService = inject(NewCustomRouteService)
  public translate = inject(TranslateService)
  public colorPointsPerDay = '#000';

  openModalMobile(item){
    this.routeService.modalItemInfo(item, true)
  }

}